document.addEventListener("DOMContentLoaded", function(event) {
  /**===  GLOBAL FUNCTIONS  ===**/
  $.fn.isInViewport = function() { // check if element is on viewport
    var _elementTop     = $(this).offset().top,
        _elementBottom  = _elementTop + $(this).outerHeight(),
        _viewportTop    = $(window).scrollTop(),
        _viewportBottom = _viewportTop + $(window).height();
    return _elementBottom > _viewportTop && _elementTop < _viewportBottom;
  };
  /*=== REGISTER GSAP PLUGINS ===*/
  gsap.registerPlugin(ScrollTrigger);
  /*=== OOS FORM FUNCTION ===*/
  let backInStockSent = false;
  var _form          = $('#back-in-stock__form'),
      _productHandle = _form.data('product-handle'),
      _productId     = _form.data('product-id'),
      _productUrl    = '/products/' + _productHandle + '.json';
  setTimeout(function(){
    if($('#th_product_bundle')){
      $('.product-form').after(_form);
    }
  }, 1500);
  if (_form.length > 0) {
    $.ajax({
      url: _productUrl,
      method: 'GET',
      dataType: 'json',
      success: function(data) {
        var _product   = data.product,
            _variants  = _product.variants,
            _pdSelects = $('.product-form .product-form__single-selector');
        if ( _form.hasClass('has-only-default-variant') ) {
          OOSDefaultVariant(_form);
        } else {
          _pdSelects.each(function() {
            var _select = $(this);
            let newVariant = [_variants[0]];

            let selectedOptions = getSelectedOptions(_pdSelects);
            console.log('Selected options: ', selectedOptions);

            let currentVariant = findCurrentVariant(selectedOptions, _variants);
            console.log('Current variant: ', currentVariant);

            if (currentVariant) {
              newVariant = [currentVariant];
            }

            _select.on('change', function() {

              let selectedOptions = getSelectedOptions(_pdSelects);
              console.log('Selected options: ', selectedOptions);

              let currentVariant = findCurrentVariant(selectedOptions, _variants);
              console.log('Current variant: ', currentVariant);

              if (currentVariant) {
                newVariant = [currentVariant];
              }

              OOSMultiVariants(_form, newVariant, _select);
              // change pdf-image
              var dataPdfImageContainer = $('.how-to-use__pdf--preview');
              if (dataPdfImageContainer.hasClass('has-variants')) {
                var dataPdfImage = dataPdfImageContainer.data();
                $.each(dataPdfImage, function(key, value) {
                  var selectVal = _select.val().replace(/ /g, '');
                  if( key.search(selectVal) >= 0 ) {
                    dataPdfImageContainer.css('--pdf-preview', `url(${value})`);
                  }
                });
              };
              // change pdf-download
              var dataPdfFileContainer = $('#how-to-use-pdf');
              if (dataPdfFileContainer.hasClass('has-variants')) {
                var dataPdfFile = dataPdfFileContainer.data();
                $.each(dataPdfFile, function(key, value) {
                  var selectVal = _select.val().replace(/ /g, '');
                  if( key.search(selectVal) >= 0 ) {
                    console.log(dataPdfFileContainer.children()[0].href)
                    dataPdfFileContainer.children()[0].href = value
                  }
                });
              };
            });
            OOSMultiVariants(_form, newVariant, _select);
          }); 
        }
        function getSelectedOptions(selects) {
          const selected = [];
          Array.from(selects).forEach(select => {
            selected.push(select.value.trim());
          });
          return selected;
        }

        function findCurrentVariant(selectedOptions, variants) {
          return variants.find(variant => {
            const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);

            return selectedOptions.every(opt => variantOptions.includes(opt));
          });
        }
        function OOSDefaultVariant(_form) {  // OOS default variant function
          var _btnIsDisabled = false;
          setTimeout(function() {
            _btnIsDisabled =  $('.product-form .product-form__add-button').prop('disabled') ? true : false;
            if ( _btnIsDisabled ) {
              $('.product-form .product-form__add-button').parent().css('display', 'none');
              _form.css('display', 'flex');
            } else {
              $('.product-form .product-form__add-button').parent().css('display', 'flex');
              _form.css('display', 'none');
            }
            OOSSubmit(_form, $(_variants)[0]);
          }, 50);
        }
        function OOSMultiVariants(_form, _variants, _select) {  // OOS Multi-variants function
          $(_variants).each(function(i, v) {
            var _btnIsDisabled = false;
            setTimeout(function() {
              _btnIsDisabled =  $('.product-form .product-form__add-button').prop('disabled') ? true : false;
              if (_select.val() == v.option1 || _select.val() == v.option2 ) {
                if ( _btnIsDisabled ) {
                  $('.product-form .product-form__add-button').parent().css('display', 'none');
                  _form.css('display', 'flex');
                  OOSSubmit(_form, v);
                }
              }
              // If button is not disabled, show the button and hide the form
              if ( _btnIsDisabled === false) {
                $('.product-form .product-form__add-button').parent().css('display', 'flex');
                _form.css('display', 'none');
                OOSSubmit(_form, v);
              }
            }, 50);
          });
        }
        function OOSSubmit(_form, variant) {  // OOS on submit form
          console.log('OOSSubmit: ', variant);
          _form.off('submit'); // Remove previous submit handler

          _form.submit(function(e){
            e.preventDefault();
            var elements = _form[0].children;
            for(var i = 0; i < elements.length; i++){
              var el = elements[i];
              if(el.id === 'email' ){
                email = el.value;
              }
            }

            const options = {
              method: 'POST',
              headers: {
                accept: 'application/vnd.api+json',
                revision: '2024-10-15',
                'content-type': 'application/vnd.api+json'
              },
              body: `{
                "data":{
                  "type":"back-in-stock-subscription",
                  "attributes":{
                    "profile":{
                      "data":{
                        "type":"profile",
                        "attributes":{
                          "email":"${email}"
                        }
                      }
                    },"channels":["EMAIL"]
                  },
                  "relationships":{
                    "variant":{
                      "data":{
                        "type":"catalog-variant",
                        "id":"$shopify:::$default:::${variant.id}"
                      }
                    }
                  }
                }
              }`
            };

            if ( backInStockSent ) return;

            backInStockSent = true;
            fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=N6Nakz', options)
              .then(res => {
                if (res.status === 202) {
                  for(var i = 0; i < elements.length; i++){
                    var el = elements[i];
                    if(el.id  === 'success' ){
                      el.style.display =  'block';
                      el.animate([
                          {opacity: '0'},
                          {transform: 'translateX(500%)'},
                          {opacity: '1'},
                      ], {
                          duration: 500
                      });
                      el.parentNode.animate([
                          {opacity: '0'},
                          {transform: 'translateX(500%)'},
                          {opacity: '1'},
                      ], {
                          duration: 500
                      });
                    } else {
                      el.style.display =  'none';
                      el.animate([
                          {opacity: '1'},
                          {transform: 'translateX(500%)'},
                          {opacity: '0'},
                      ], {
                          duration: 500
                      });
                    }
                  }
                  console.log('Submission was successful.');
                } else {
                  console.log('An error occurred.', res)
                }
              })
              .catch(err =>  console.log('An error occurred.', err));
          });
        }
      },
      error: function(e) { console.log('Error: ', e.message) }
    });
  }
  /*=== LANDING PAGE - scrollTrigger ===*/
  if ( document.getElementById('scroll-magic-data') ) {
    ScrollTrigger.matchMedia({
      "(min-width: 769px)": function() {
        // style tag to inject
        function addStyle(styles) {
          var css = document.createElement('style');
          css.type = 'text/css';
          if (css.styleSheet) 
              css.styleSheet.cssText = styles;
          else 
              css.appendChild(document.createTextNode(styles));
          document.getElementsByTagName("head")[0].appendChild(css);
        }
        var styles = '#landing-product-landing-product-1 .landing-product__wrapper { top: 50px !important; }';
        window.onload = function() { addStyle(styles) };
        // scrollTrigger animation
        var scrollMagicScenes = JSON.parse(document.getElementById('scroll-magic-data').textContent);
        var targetSceneProductFormId = scrollMagicScenes.scenes[0].scene_product_form; // clone first form
        var targetSceneProductFormNode = document.querySelector(`#${targetSceneProductFormId}`).cloneNode(true);
        if ( document.querySelector(`${scrollMagicScenes.scenes[0].scene_class}`).querySelector('.product-icons') ) {
          var firstSceneProductIcons = document.querySelector(`${scrollMagicScenes.scenes[0].scene_class}`).querySelector('.product-icons').cloneNode(true); // Clone first product-icons
        }
        ScrollTrigger.create({
          trigger: `.landing-products`,
          start: "+=40px +=100px",
          end: "bottom bottom",
          pin: `${scrollMagicScenes.scenes[0].scene_class} .landing-product__wrapper`,
          // markers: true, // -> for debug
          scrub: 1,
          snap: {
            snapTo: 1 / (scrollMagicScenes.scenes.length - 1),
            duration: 0.5,
            ease: 'power2.inOut',
            onInterrupt: self => {
              var sectionHeight = 1/(scrollMagicScenes.scenes.length - 1);
              var currentSection = parseInt(self.progress.toFixed(2) / sectionHeight.toFixed(2));
              scrollMagicScenes.scenes.forEach(function(section, index) {
                var targetScene = document.querySelector(`${scrollMagicScenes.scenes[0].scene_class}`);
                if(index === currentSection) {
                  targetScene.querySelectorAll('.aos-init').forEach(function(el, i) {
                    el.classList.remove('aos-animate');
                  });
                }
              });
            }
          },
          onSnapComplete: self => {
            var sectionHeight = 1/(scrollMagicScenes.scenes.length - 1);
            var currentSection = parseInt(self.progress.toFixed(2) / sectionHeight.toFixed(2));
            scrollMagicScenes.scenes.forEach(function(section, index) {
              var targetScene = document.querySelector(`${scrollMagicScenes.scenes[0].scene_class}`);
              if(index === currentSection) {
                targetScene.querySelectorAll('.aos-init').forEach(function(el, i) {
                  el.classList.add('aos-animate');
                });
              }
            });
          },
          onUpdate: self => {
            var sectionHeight = 1/(scrollMagicScenes.scenes.length - 1);
            var currentSection = parseInt(self.progress.toFixed(2) / sectionHeight.toFixed(2));
            scrollMagicScenes.scenes.forEach(function(section, index) {
              var targetScene = document.querySelector(`${scrollMagicScenes.scenes[0].scene_class}`);
              var productFormContainer = document.createElement('div');
              var productIconsContainer = document.createElement('div');
              if(index === currentSection) {
                targetScene.querySelectorAll('.aos-init').forEach(function(el, i) {
                  el.classList.remove('aos-animate');
                });
                targetScene.classList.add('masked');
                targetScene.querySelector('.landing-product--index').innerHTML = section.scene_title;
                targetScene.querySelector('.landing-product--title').innerHTML = section.scene_product_title;
                targetScene.querySelector('.landing-product--description').innerHTML = section.scene_product_description;
                targetScene.querySelector('.product-icons--wrapper').innerHTML = '';
                targetScene.classList.remove('masked');
                if (index === 0) {
                  var productFormNode = targetSceneProductFormNode.cloneNode(true);
                  productFormContainer.appendChild(productFormNode);
                  targetScene.querySelector('.landing-product-cart').innerHTML = productFormContainer.innerHTML;
                  if (firstSceneProductIcons) {
                    var productIconsNode = firstSceneProductIcons.cloneNode(true);
                    productIconsContainer.appendChild(productIconsNode);
                    targetScene.querySelector('.product-icons--wrapper').innerHTML = productIconsContainer.innerHTML;
                  }
                } else {
                  var productFormNode = document.querySelector(`#${section.scene_product_form}`).cloneNode(true);
                  productFormContainer.appendChild(productFormNode);
                  targetScene.querySelector('.landing-product-cart').innerHTML = productFormContainer.innerHTML;
                  if ( targetScene.querySelector('.product-icons') ) {
                    var productIconsNode = targetScene.querySelector('.product-icons').cloneNode(true);
                    productIconsContainer.appendChild(productIconsNode);
                    targetScene.querySelector('.product-icons--wrapper').innerHTML = productIconsContainer.innerHTML;
                  }
                }
              }
            });
          },
        });
      }
    });
  };
  /*== PDP slider sticki on window scroll ==*/
  if ( $('.product-gallery__carousel-wrapper').length > 0 ) {
    $(window).scroll(function() {
      var scrollTop = $(document).scrollTop(),
          productSliderContainer = $('.product-block-list__item--gallery'),
          viewportHeight = $(window).height(),
          topCard = Math.abs( (viewportHeight - productSliderContainer.find('.card').height() ) / 2  );
      if ( scrollTop > 30 && productSliderContainer.height() > scrollTop ) {
        productSliderContainer.isInViewport() 
          ? productSliderContainer.find('.card').css('top', `${scrollTop + topCard}px`) 
          : productSliderContainer.find('.card').css('top', '140px');
      } else {
        productSliderContainer.find('.card').css('top', '140px');
      }
    });
  }
  // landing-page hero height
  function heroHeight() {
    var heroContainer = $('[data-section-id="hero"]');
    if (heroContainer && heroContainer.find('.hero-description').length > 0) {
      var textHeight = heroContainer.find('.hero-description')[0].clientHeight;
      heroContainer.find('#hero-section').css('min-height', textHeight+50);
    }
  }
  heroHeight();
  $(window).on('resize', function() { heroHeight() });
});